module.exports = __webpack_public_path__ + "static/media/eventScheduler.ac2dfe48.svg";